import { instantExecutor, timeoutExecutor } from "../core/executor";
import { INode } from "./node";
/**
 * Application Node
 * @class AppNode
 * @extends INode
 */
export class AppNode extends INode {
    /**
     * @param options {Object} Application options
     */
    constructor(options) {
        super();
        this.$run = (options === null || options === void 0 ? void 0 : options.executor) || ((options === null || options === void 0 ? void 0 : options.freezeUi) === false ? timeoutExecutor : instantExecutor);
        this.$debugUi = (options === null || options === void 0 ? void 0 : options.debugUi) || false;
    }
}
/**
 * Represents a Vasille.js application
 * @class App
 * @extends AppNode
 */
export class App extends AppNode {
    /**
     * Constructs an app node
     * @param node {Element} The root of application
     * @param options {Object} Application options
     */
    constructor(node, options) {
        super(options);
        this.$.node = node;
        this.$preinit(this, this);
        this.$seal();
    }
    $$appendNode(node) {
        const $ = this.$;
        $.app.$run.appendChild($.node, node);
    }
}
